import React from 'react';
import {
  RegisterOptions,
  useFormContext,
} from 'react-hook-form/dist/index.ie11';
import { Copy } from '@grubhubprod/gh-cookbook-react/dist';
import { Link as CookbookLink } from '@grubhubprod/gh-cookbook-react';
import { CookbookCheckboxWrapper } from 'src/components/CookbookCheckboxWrapper/CookbookCheckboxWrapper';

export interface TermsAndConditionsControlProps {
  name: string;
  id: string;
  rules?: RegisterOptions;
}

export function TermsAndConditionsControl({
  name,
  id,
  rules = {},
}: TermsAndConditionsControlProps): JSX.Element {
  const { control } = useFormContext();

  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>): void => {
    e.stopPropagation();
  };

  return (
    <CookbookCheckboxWrapper
      name={name}
      id={id}
      control={control}
      rules={rules}
      label={
        <Copy variant="body">
          On behalf of my company, I agree to the{' '}
          <CookbookLink
            variant="muted"
            href="https://lp.grubhub.com/grubhub-corporate-terms-of-service/"
            target="_blank"
            rel="noreferrer noopener"
            onClick={handleLinkClick}
          >
            Grubhub for Business Terms and Conditions
          </CookbookLink>
          , which govern our use of any Grubhub for Business products.
        </Copy>
      }
    />
  );
}
